module.exports = __webpack_public_path__ + "img/14.97ec3837.webp";